export enum FileOfflineStatusEnum {
  Pending = 'Pending',
  Downloading = 'Downloading',
  Downloaded = 'Downloaded',
}
